export const SECTION_IDS = {
    contact: 'contact',
    pricing: 'pricing',
    product: 'product',
    report : 'report',
    top    : 'top',
} as const;

export const SECTION_HREFS = {
    contact: '#' + SECTION_IDS.contact,
    pricing: '#' + SECTION_IDS.pricing,
    product: '#' + SECTION_IDS.product,
    report : '#' + SECTION_IDS.report,
    top    : '#' + SECTION_IDS.top,
} as const;
